(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[238],{

/***/ 8718:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[handle]",
      function () {
        return __webpack_require__(20196);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Product; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(52050);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/hooks/index.js + 64 modules
var hooks = __webpack_require__(74424);
// EXTERNAL MODULE: ./src/snippets/index.js + 352 modules
var snippets = __webpack_require__(81234);
// EXTERNAL MODULE: ./src/store/index.js + 12 modules
var store = __webpack_require__(27695);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/templates/product/Main/Header/Price/Price.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        minHeight: [
            0,
            "19px"
        ],
        minWidth: "40px",
        mr: [
            4,
            4
        ],
        position: "relative"
    };
    this.loader = {
        height: "12px",
        color: "mediumDarkGray",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
    this.badges = {
        variant: "flex.row.start.center",
        width: "100%",
        ml: 5
    };
    // Amount styles
    this.badge = {
        oneTime: {
            variant: "badges.sellingPlan"
        },
        subscription: {
            variant: "badges.sellingPlan",
            bg: "dark"
        },
        sale: {
            variant: "badges.sellingPlan",
            bg: "red",
            ml: 3
        }
    };
    this.price = {
        lineThrough: {
            variant: "text.base",
            textDecoration: "line-through",
            ml: 4,
            color: "mediumDarkGray"
        },
        new: {
            variant: "text.base",
            color: "red"
        },
        regular: {
            variant: "text.base"
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Header/Price/Amount.jsx



var Amount = themed(function(param) {
    var theme = param.theme, compareAtPriceV2 = param.compareAtPriceV2, isOnSale = param.isOnSale, priceV2 = param.priceV2;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Amount.displayName,
        sx: theme.price,
        children: isOnSale ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: theme.price.new,
                    children: priceV2.locale
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                    sx: theme.price.lineThrough,
                    children: compareAtPriceV2.locale
                })
            ]
        }) : // onetime full price
        /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
            sx: theme.price.regular,
            children: priceV2.locale
        })
    });
});
Amount.displayName = "Amount";

;// CONCATENATED MODULE: ./src/templates/product/Main/Header/Price/Price.jsx






var Price = themed(function(param) {
    var theme = param.theme, selectedVariant = param.selectedVariant;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        sx: theme.wrapper,
        children: selectedVariant && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(snippets/* Locale.Variant */.go.Variant, {
            variant: selectedVariant,
            children: [
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Price */.go.Price, {
                    children: function(props) {
                        return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Amount, (0,_object_spread/* default */.Z)({}, props));
                    }
                }),
                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Locale.Loader */.go.Loader, {
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: theme.loader
                    })
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./src/templates/product/Main/Header/Price/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Header/Header.theme.js

var Header_theme_themed = (0,create/* create */.U)(new function() {
    this.metadata = {
        maxWidth: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        pb: [
            6,
            null,
            8
        ]
    };
    this.title = {
        variant: "text.h2",
        minHeight: [
            "36x",
            "40px"
        ],
        fontSize: [
            "24px",
            "40px"
        ],
        lineHeight: "normal",
        fontWeight: [
            "400",
            "300"
        ],
        letterSpacing: [
            "0.48px",
            "-0.03em"
        ]
    };
    this.variant = {
        color: "mediumDarkGray",
        fontSize: [
            3,
            4
        ],
        minHeight: "22px"
    };
    this.priceAfterpayWrapper = {
        variant: "flex.row.start.center",
        flexWrap: "wrap",
        mt: 6
    };
    this.price = {
        text: "text.h2",
        minHeight: 40
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Header/Header.jsx








var Header = Header_theme_themed(function(_param) {
    var theme = _param.theme, selectedVariant = _param.selectedVariant, currentProduct = _param.currentProduct, titles = _param.titles, isMobile = _param.isMobile, props = (0,_object_without_properties/* default */.Z)(_param, [
        "theme",
        "selectedVariant",
        "currentProduct",
        "titles",
        "isMobile"
    ]);
    var isMobileViewport = (0,hooks/* useMatchMedia */.ag)("(max-width: 767px)");
    var isVisibleHeader = isMobile && isMobileViewport || !isMobile && !isMobileViewport;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: (0,_object_spread/* default */.Z)({}, theme.metadata, props.sx),
        children: [
            isVisibleHeader ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h1",
                sx: theme.title,
                children: titles.product
            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Heading */.X6, {
                as: "h2",
                sx: theme.title,
                children: titles.product
            }),
            (titles === null || titles === void 0 ? void 0 : titles.variant) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.variant,
                children: titles.variant
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.priceAfterpayWrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Price, {
                        selectedVariant: selectedVariant
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* OkendoStars */.oF, {
                        legacyResourceId: currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.legacyResourceId,
                        withScroll: true,
                        sx: {
                            mb: 0,
                            mt: 0
                        },
                        className: "before:content-['_|_'] before:mr-2",
                        isPdp: true
                    })
                ]
            })
        ]
    });
});
Header.displayName = "ProductHeader";

;// CONCATENATED MODULE: ./src/templates/product/Main/Header/index.js


// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper.js + 8 modules
var react_swiper = __webpack_require__(48148);
// EXTERNAL MODULE: ../node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(95445);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(67296);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/scrollbar/scrollbar.js
var scrollbar = __webpack_require__(57987);
// EXTERNAL MODULE: ../node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(15753);
;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Thumbs/ThumbsNavigation/ThumbsNavigation.theme.js

var ThumbsNavigation_theme_themed = (0,create/* create */.U)(new function() {
    this.up = {
        transition: "opacity 0.15s ease-in-out",
        width: "20px",
        cursor: "pointer",
        position: "absolute",
        bottom: "calc(100% + 12px)",
        left: "50%",
        transform: "translateX(-50%)"
    };
    this.down = {
        transition: "opacity 0.15s ease-in-out",
        width: "20px",
        cursor: "pointer",
        position: "absolute",
        top: "calc(100% + 12px)",
        left: "50%",
        transform: "translateX(-50%)"
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Thumbs/ThumbsNavigation/ThumbsNavigation.jsx






var ThumbsNavigation = ThumbsNavigation_theme_themed(function(param) {
    var theme = param.theme, swiper = param.swiper, count = param.count;
    var showNavPerBp = (0,hooks/* useBreakpointValue */.Sx)([
        false,
        false,
        count > 5,
        count > 6
    ]);
    var ref = (0,react.useState)(true), isStart = ref[0], setIsStart = ref[1];
    var ref1 = (0,react.useState)(false), isEnd = ref1[0], setIsEnd = ref1[1];
    var ref2 = (0,react.useState)(false), showNav = ref2[0], setShowNav = ref2[1];
    var setStartAndEndOnSwiperChange = (0,react.useCallback)(function() {
        if (!swiper) return;
        setIsStart(swiper.isBeginning);
        setIsEnd(swiper.isEnd);
        swiper.on("slideChange", function() {
            setIsStart(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
        });
    }, [
        swiper
    ]);
    (0,react.useEffect)(function() {
        setStartAndEndOnSwiperChange();
    }, [
        swiper
    ]);
    (0,react.useEffect)(function() {
        setShowNav(showNavPerBp);
    }, [
        showNavPerBp
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                alt: "chevron",
                viewBox: "0 0 16 16",
                src: "/svgs/chevron/up.svg#up",
                onClick: function() {
                    return swiper.slidePrev();
                },
                role: "button",
                sx: (0,_object_spread/* default */.Z)({
                    display: showNav ? "block" : "none",
                    opacity: showNav && isStart ? 0 : 1,
                    pointerEvents: showNav && isStart ? "none" : "auto"
                }, theme.up)
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                alt: "chevron",
                viewBox: "0 0 16 16",
                src: "/svgs/chevron/down.svg#down",
                onClick: function() {
                    return swiper.slideNext();
                },
                role: "button",
                sx: (0,_object_spread/* default */.Z)({
                    display: showNav ? "block" : "none",
                    opacity: showNav && isEnd ? 0 : 1,
                    pointerEvents: showNav && isEnd ? "none" : "auto",
                    transition: "opacity 0.15s ease-in-out"
                }, theme.down)
            })
        ]
    });
});
ThumbsNavigation.displayName = "ThumbsNavigation";

;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Thumbs/ThumbsNavigation/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Thumbs/Thumbs.theme.js

var Thumbs_theme_themed = (0,create/* create */.U)(new function() {
    this.thumbs = {
        display: [
            "none",
            null,
            "block"
        ],
        width: "80px",
        minWidth: "80px",
        mr: "28px",
        position: "relative",
        height: [
            "calc((80px * 5) + (12px * 4))",
            null,
            null,
            "calc((80px * 6) + (12px * 5))", 
        ]
    };
    this.swiper = {
        height: "100%",
        ".swiper-slide": {
            pb: "100%",
            height: "auto !important",
            position: "relative"
        }
    };
    this.thumb = {
        width: "100%",
        height: "100%",
        cursor: "pointer",
        borderRadius: "4px",
        position: "absolute",
        overflow: "hidden",
        top: 0,
        left: 0,
        transition: "all .25s ease-in-out",
        "&:hover": {
            opacity: 1
        },
        inactive: {
            border: function(t) {
                return "1px solid ".concat(t.colors.gray);
            }
        },
        active: {
            border: function(t) {
                return "1px solid ".concat(t.colors.text);
            }
        },
        default: {
            image: {
                position: "absolute",
                width: "100%",
                height: "80px",
                display: "block",
                objectFit: "cover",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            text: {
                position: "absolute",
                transform: "translate(-50%, -50%)",
                top: "50%",
                left: "50%",
                zIndex: 1,
                fontSize: 1,
                textAlign: "center"
            }
        }
    };
    this.play = {
        color: "white",
        position: "absolute",
        width: "38px",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Thumbs/Thumbs.jsx








var Thumbs = Thumbs_theme_themed(function(param) {
    var theme = param.theme, medias = param.medias, activeIndex = param.activeIndex, goToSlide = param.goToSlide;
    var ref = (0,react.useState)(), swiper = ref[0], setSwiper = ref[1];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Thumbs.displayName,
        sx: theme.thumbs,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                onSwiper: setSwiper,
                slidesPerView: 5,
                direction: "vertical",
                spaceBetween: 12,
                preventClicksPropagation: false,
                preventClicks: false,
                watchOverflow: true,
                grabCursor: (medias === null || medias === void 0 ? void 0 : medias.length) > 5,
                breakpoints: {
                    1280: {
                        slidesPerView: 6,
                        grabCursor: (medias === null || medias === void 0 ? void 0 : medias.length) > 6
                    }
                },
                sx: theme.swiper,
                children: medias === null || medias === void 0 ? void 0 : medias.map(function(media, index) {
                    var ref;
                    var isActive = activeIndex === index;
                    var image = (media === null || media === void 0 ? void 0 : media.image) || (media === null || media === void 0 ? void 0 : (ref = media.preview) === null || ref === void 0 ? void 0 : ref.image);
                    var isVideo = (media === null || media === void 0 ? void 0 : media.mediaContentType) === "VIDEO";
                    var src = image === null || image === void 0 ? void 0 : image.originalSrc;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                            "data-comp": "Thumb",
                            onClick: function() {
                                return goToSlide(index);
                            },
                            role: "button",
                            tabIndex: "-1",
                            "aria-hidden": "true",
                            sx: (0,_object_spread/* default */.Z)({}, theme.thumb, isActive ? theme.thumb.active : theme.thumb.inactive),
                            children: [
                                /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                                    alt: media.alt,
                                    width: 156,
                                    height: 156,
                                    images: [
                                        {
                                            src: src,
                                            ratio: 1,
                                            width: 100
                                        }
                                    ]
                                }),
                                isVideo && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                                    alt: "play",
                                    src: "/svgs/play.svg#play",
                                    viewBox: "0 0 38 38",
                                    sx: theme.play
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ThumbsNavigation, {
                swiper: swiper,
                count: (medias === null || medias === void 0 ? void 0 : medias.length) || 0
            })
        ]
    });
});
Thumbs.displayName = "Thumbs";

;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Thumbs/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Media.theme.js

var Media_theme_themed = (0,create/* create */.U)(new function() {
    this.medias = {
        width: "100%",
        alignSelf: "flex-start",
        justifySelf: "flex-end",
        display: "flex",
        position: [
            "relative",
            null,
            "sticky"
        ],
        top: [
            "initial",
            null,
            "calc(var(--header-height, 0px) + 10px)"
        ]
    };
    this.swiper = {
        flex: 1,
        position: "relative"
    };
    this.slide = {
        m: 0,
        outline: "none"
    };
    this.bullets = {
        mt: 6,
        display: [
            "flex",
            null,
            "none"
        ],
        justifyContent: "center",
        gap: 9,
        width: "100%",
        height: "8px",
        ".swiper-pagination-bullet-active": {
            bg: "text"
        },
        ".swiper-pagination-bullet": {
            cursor: "pointer"
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Media/Media.jsx













var Media = Media_theme_themed(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant, aboveTheFold = param.aboveTheFold, preload = param.preload;
    var selectedMedia = (0,store/* useRecoilValue */.sJ)(store/* default.selectedMedia$ */.ZP.selectedMedia$);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedOptions */.C)(), 1), selectedOptions = ref[0];
    var ref1 = (0,react.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    var ref2 = (0,react.useState)(), swiper = ref2[0], setSwiper = ref2[1];
    var goToSlide = (0,react.useCallback)(function(index) {
        swiper.slideTo(index);
        setActiveIndex(index);
    }, [
        swiper
    ]);
    (0,react.useEffect)(function() {
        if (!swiper || !swiper.initialized) return undefined;
        var handleSlideChange = function(_swiper) {
            setActiveIndex(_swiper.realIndex);
        };
        swiper.on("slideChange", handleSlideChange);
        return function() {
            swiper.off("slideChange", handleSlideChange);
        };
    }, [
        swiper
    ]);
    // on color swatch change go back to first slide
    (0,react.useEffect)(function() {
        var ref;
        if (!swiper || !swiper.initialized) return;
        if (!product) return;
        if (product.isGrouped) {
            swiper.slideTo(0);
            return;
        }
        var variantImageIndex = (ref = product.media) === null || ref === void 0 ? void 0 : ref.findIndex(function(param) {
            var image = param.image;
            var ref;
            return (image === null || image === void 0 ? void 0 : image.id) === (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.image) === null || ref === void 0 ? void 0 : ref.id);
        });
        if (variantImageIndex >= 0) {
            swiper.slideTo(variantImageIndex);
        }
    }, [
        selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.Color,
        product === null || product === void 0 ? void 0 : product.id,
        swiper
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Media.displayName,
        sx: theme.medias,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Thumbs, {
                medias: selectedMedia,
                activeIndex: activeIndex,
                goToSlide: goToSlide
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    position: "relative",
                    flex: 1,
                    pb: [
                        10,
                        null,
                        0
                    ]
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(react_swiper/* Swiper */.t, {
                        "data-comp": "MediaSwiper",
                        modules: [
                            navigation/* default */.Z,
                            scrollbar/* default */.Z,
                            a11y/* default */.Z
                        ],
                        pagination: {
                            el: ".swiper-pagination",
                            type: "bullets",
                            clickable: true
                        },
                        preloadImages: true,
                        fadeEffect: {
                            crossFade: true
                        },
                        onSwiper: setSwiper,
                        slidesPerView: 1,
                        freeMode: false,
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.swiper), {
                            cursor: (selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.length) > 1 ? "grab" : "auto"
                        }),
                        watchOverflow: true,
                        children: selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.map(function(media, index) {
                            var isPrimaryIamge = index === 0 && aboveTheFold;
                            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(swiper_slide/* SwiperSlide */.o, {
                                virtualIndex: index,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ShopifyMedia */.WN, {
                                    media: media,
                                    bgColor: "lightGray",
                                    aboveTheFold: isPrimaryIamge,
                                    preload: isPrimaryIamge
                                })
                            }, index);
                        })
                    }),
                    !swiper && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            width: "100%",
                            pb: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            bg: "lightGray",
                            zIndex: 1
                        }
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Badge */.Ct, {
                        handle: product === null || product === void 0 ? void 0 : product.handle,
                        product: product,
                        isPdp: true
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                        className: "swiper-pagination",
                        sx: theme.bullets
                    })
                ]
            })
        ]
    });
});
Media.displayName = "Media";

;// CONCATENATED MODULE: ./src/templates/product/Main/Media/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Icons/Icons.theme.js

var Icons_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "flex.row.start.center",
        flexWrap: "wrap",
        gap: [
            6,
            11
        ],
        mb: 11
    };
    this.iconsRow = {
        variant: "flex.row.start.start"
    };
    this.icon = {
        width: "20px",
        mr: 3
    };
    this.label = {
        variant: "text.label.2",
        maxWidth: "175px",
        mt: "1px"
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Icons/Icons.jsx








var Icons = Icons_theme_themed(function(param) {
    var theme = param.theme, product = param.product;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var iconsData = settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : (ref1 = ref.icons) === null || ref1 === void 0 ? void 0 : ref1.list;
    var iconsDataDep = (iconsData === null || iconsData === void 0 ? void 0 : iconsData.length) ? iconsData === null || iconsData === void 0 ? void 0 : iconsData.map(function(v) {
        var ref;
        return v.tag + v.label + ((ref = v.icon) === null || ref === void 0 ? void 0 : ref.src);
    }).join("") : null;
    var icons = (0,react.useMemo)(function() {
        var ref;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.length)) return [];
        return product.tags.reduce(function(arr, tag) {
            var ref;
            if (!tag.startsWith("icon::")) return arr;
            var tagValue = (ref = tag.split("icon::")[1]) === null || ref === void 0 ? void 0 : ref.toLowerCase().trim();
            return tagValue ? (0,_to_consumable_array/* default */.Z)(arr).concat([
                tagValue
            ]) : arr;
        }, []);
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var iconsDep = icons.join("");
    var iconsMap = (0,react.useMemo)(function() {
        if (!icons.length || !(iconsData === null || iconsData === void 0 ? void 0 : iconsData.length)) return {};
        return iconsData.reduce(function(obj, icon, index) {
            var tag = icon.tag.toLowerCase().trim();
            obj[tag] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, icon), {
                tag: tag,
                order: index
            });
            return obj;
        }, {});
    }, [
        iconsDataDep,
        iconsDep
    ]);
    var iconsMapDep = Object.values(iconsMap).map(function(v) {
        return v.tag;
    }).join("");
    var sortedIcons = (0,react.useMemo)(function() {
        if (!icons.length || !iconsMapDep) return [];
        return (0,_to_consumable_array/* default */.Z)(icons).sort(function(a, b) {
            var ref, ref1, ref2, ref3;
            if (((ref = iconsMap[a]) === null || ref === void 0 ? void 0 : ref.order) < ((ref1 = iconsMap[b]) === null || ref1 === void 0 ? void 0 : ref1.order)) return -1;
            if (((ref2 = iconsMap[a]) === null || ref2 === void 0 ? void 0 : ref2.order) > ((ref3 = iconsMap[b]) === null || ref3 === void 0 ? void 0 : ref3.order)) return 1;
            return 0;
        });
    }, [
        iconsDep,
        iconsMapDep
    ]);
    return sortedIcons.length ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Icons.displayName,
        sx: theme.wrapper,
        children: sortedIcons.map(function(item) {
            var ref;
            var icon = iconsMap[item];
            return icon ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.iconsRow,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                        alt: icon.tag,
                        src: ((ref = icon.icon) === null || ref === void 0 ? void 0 : ref.src) || "/svgs/default-image.svg",
                        sx: theme.icon,
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.label,
                        children: icon.label
                    })
                ]
            }, icon.tag) : null;
        })
    }) : null;
});
Icons.displayName = "Icons";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Icons/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Options/Option/Option.theme.js

var Option_theme_themed = (0,create/* create */.U)(new function() {
    this.option = {
        mt: 0,
        pb: 10,
        width: "100%",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.header = {
        variant: "flex.row.start.center",
        mt: 10,
        mb: 3
    };
    this.name = {
        variant: "text.label.1",
        mr: 4
    };
    this.selectedOption = {
        color: "mediumDarkGray"
    };
    this.values = {
        variant: "flex.row.start",
        flexWrap: "wrap",
        flexBasis: "100%",
        mr: "auto",
        gap: 4,
        pl: 0
    };
    this.value = {
        px: 5,
        alignItems: "center",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        height: "40px",
        minWidth: "64px",
        borderRadius: "44px",
        position: "relative",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        available: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "text"
            }
        },
        unavailable: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.mediumDarkGray);
                },
                bg: "background",
                color: "mediumDarkGray"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "mediumGray"
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Options/Option/Option.jsx







var Option = Option_theme_themed(function(param) {
    var theme = param.theme, options = param.options, optionName = param.optionName;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedOptions */.C)(), 2), selectedOptions = ref1[0], setSelectedOptions = ref1[1];
    var selectedOptionIsAvailable = (0,hooks/* useSelectedOptionIsAvailable */.gf)();
    var selectedOption = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[optionName];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": "".concat(Option.displayName, "-").concat(optionName),
        sx: theme.option,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.header,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.name,
                        children: optionName
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.selectedOption,
                        children: selectedOption
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                sx: theme.values,
                children: (ref = options[optionName]) === null || ref === void 0 ? void 0 : ref.map(function(value) {
                    var isSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[optionName]) === value;
                    var isAvailable = selectedOptionIsAvailable((0,_define_property/* default */.Z)({}, optionName, value));
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                            variant: "buttons.plain",
                            onClick: function() {
                                setSelectedOptions((0,_define_property/* default */.Z)({}, optionName, value));
                            },
                            sx: (0,_object_spread/* default */.Z)({}, theme.value, isAvailable ? isSelected ? theme.value.available.selected : theme.value.available.unselected : isSelected ? theme.value.unavailable.selected : theme.value.unavailable.unselected),
                            children: value
                        })
                    }, value);
                })
            })
        ]
    });
});
Option.displayName = "Option";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Options/Option/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Options/Options.theme.js

var Options_theme_themed = (0,create/* create */.U)(new function() {
    this.options = {
        variant: "flex.column",
        width: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Options/Options.jsx




var Options = Options_theme_themed(function(param) {
    var theme = param.theme, options = param.options, handle = param.handle, image = param.image;
    var ref;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": Options.displayName,
        sx: theme.options,
        children: options && ((ref = Object.keys(options)) === null || ref === void 0 ? void 0 : ref.map(function(optionName, index) {
            // Each option group. e.g Sizes, Colors..
            var option = options[optionName];
            if ((option === null || option === void 0 ? void 0 : option.length) < 2 || (option === null || option === void 0 ? void 0 : option[0]) === "Default Title") return null;
            return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Option, {
                optionName: optionName,
                index: index,
                options: options,
                handle: handle,
                image: image
            }, optionName);
        }))
    });
});
Options.displayName = "Options";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Options/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/SizeOptions/SizeOptions.theme.js

var SizeOptions_theme_themed = (0,create/* create */.U)(new function() {
    this.option = {
        mt: 0,
        pb: 10,
        width: "100%",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.header = {
        variant: "flex.row.start.center",
        mt: 10,
        mb: 3
    };
    this.name = {
        variant: "text.label.1",
        mr: 4
    };
    this.size = {
        color: "mediumDarkGray"
    };
    this.values = {
        variant: "flex.row.start",
        flexWrap: "wrap",
        flexBasis: "100%",
        mr: "auto",
        gap: 4,
        pl: 0
    };
    this.value = {
        px: 5,
        alignItems: "center",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        height: "40px",
        minWidth: "64px",
        borderRadius: "44px",
        position: "relative",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        available: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "text"
            }
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/SizeOptions/SizeOptions.jsx






var SizeOptions = SizeOptions_theme_themed(function(param) {
    var theme = param.theme, product = param.product;
    var ref;
    var options = product === null || product === void 0 ? void 0 : (ref = product.toggles) === null || ref === void 0 ? void 0 : ref.size;
    var selectedSize = (0,react.useMemo)(function() {
        var ref, ref1;
        return ((ref1 = product === null || product === void 0 ? void 0 : (ref = product.title) === null || ref === void 0 ? void 0 : ref.split("|")[2]) === null || ref1 === void 0 ? void 0 : ref1.trim()) || null;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return (options === null || options === void 0 ? void 0 : options.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": SizeOptions.displayName,
        sx: theme.option,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.header,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.name,
                        children: "Size"
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: theme.size,
                        children: selectedSize
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                as: "ul",
                sx: theme.values,
                children: options.map(function(param) {
                    var title = param.title, handle = param.handle, url = param.url;
                    var isSelected = product.handle === handle;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        as: "li",
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                            href: url,
                            onClick: function(e) {
                                if (isSelected) e.preventDefault();
                            },
                            sx: (0,_object_spread/* default */.Z)({}, theme.value, isSelected ? theme.value.available.selected : theme.value.available.unselected),
                            children: title
                        })
                    }, handle);
                })
            })
        ]
    }) : null;
});
SizeOptions.displayName = "SizeOptions";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/SizeOptions/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/ColorOptions/ColorOptions.theme.js

var ColorOptions_theme_themed = (0,create/* create */.U)(new function() {
    this.option = {
        mt: 0,
        pb: 6,
        width: "100%",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.header = {
        variant: "flex.row.start.center",
        mt: 8,
        mb: 5
    };
    this.name = {
        variant: "text.label.1",
        mr: 4
    };
    this.color = {
        color: "mediumDarkGray"
    };
    this.values = function(totalSquares) {
        return {
            display: "grid",
            pl: 0,
            mr: "auto",
            gap: 6,
            gridTemplateColumns: "repeat(".concat(totalSquares, ", calc((").concat(1 / totalSquares, " * 100%) - (").concat(totalSquares - 1, " * 12px / ").concat(totalSquares, ")))"),
            width: "100%",
            maxWidth: "".concat(64 * totalSquares + (totalSquares - 1) * 12, "px")
        };
    };
    this.colorOptionWrapper = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%"
    };
    this.value = {
        p: 4,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        fontSize: "12px",
        width: "100%",
        borderRadius: "4px",
        position: "relative",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            color: "mediumDarkGray",
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            },
            '[data-comp="Picture"]': {
                opacity: 1
            }
        },
        available: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "text"
            }
        },
        unavailable: {
            selected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.text);
                },
                bg: "background",
                color: "text"
            },
            unselected: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.gray);
                },
                bg: "background",
                color: "gray"
            }
        }
    };
    this.colorName = {
        fontSize: "9px",
        lineHeight: "11px",
        textAlign: "center",
        mt: 2,
        color: "text",
        fontWeight: "normal",
        width: "100%",
        maxWidth: "60px",
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        wordBreak: "normal",
        overflowWrap: "break-word",
        hyphens: "auto"
    };
    this.seeAllWrapper = {
        position: "relative",
        pb: "100%"
    };
    this.seeAll = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "4px",
        mb: 6,
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        bg: "background",
        color: "text",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            border: function(t) {
                return "1px solid ".concat(t.colors.mediumDarkGray);
            }
        },
        icon: {
            width: "20px",
            color: "text"
        },
        text: {
            fontSize: "10px",
            lineHeight: "12px"
        }
    };
    this.tabs = {
        display: "flex",
        gap: 0,
        mt: 8,
        mb: 4,
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.tab = {
        px: 0,
        py: 3,
        mr: 8,
        bg: "transparent",
        border: "none",
        borderBottom: "2px solid transparent",
        color: "mediumDarkGray",
        fontSize: "14px",
        fontWeight: "450",
        cursor: "pointer",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            color: "text"
        },
        active: {
            color: "text",
            borderBottomColor: "text",
            fontWeight: "500"
        }
    };
    this.colorGrid = {
        display: "grid",
        pl: 0,
        gap: 6,
        gridTemplateColumns: "repeat(auto-fill, minmax(54px, 1fr))",
        width: "100%",
        maxWidth: "100%"
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/ColorOptions/ColorOption.jsx








var ColorOption = ColorOptions_theme_themed(function(param) {
    var theme = param.theme, handle = param.handle, selectedColor = param.selectedColor, setSelectedOptions = param.setSelectedOptions, _isGrouped = param.isGrouped, isGrouped = _isGrouped === void 0 ? false : _isGrouped, tmp = param.inventory, initialInventory = tmp === void 0 ? {} : tmp;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var color = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        if (!product) return null;
        return (ref2 = (ref1 = product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return tag.match(/color::/gi);
        })) === null || ref1 === void 0 ? void 0 : ref1.split("::")[1]) === null || ref2 === void 0 ? void 0 : ref2.trim();
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var firstImage = (0,react.useMemo)(function() {
        var ref, ref1;
        return (ref1 = product === null || product === void 0 ? void 0 : (ref = product.media) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.mediaContentType === "IMAGE";
        })) === null || ref1 === void 0 ? void 0 : ref1.image;
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var isSelected = color === selectedColor;
    var _ref = (initialInventory === null || initialInventory === void 0 ? void 0 : initialInventory.id) ? {
        inventory: initialInventory,
        finished: true
    } : (0,dist.useProductInventoryByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle,
        withQuantity: true
    }), inventory = _ref.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "inventory"
    ]);
    var isGiftCard = (inventory === null || inventory === void 0 ? void 0 : inventory.handle) === "brumate-e-gift-card" || (product === null || product === void 0 ? void 0 : product.handle) === "brumate-e-gift-card";
    var isSoldOut = (0,react.useMemo)(function() {
        if (!(inventoryStatus === null || inventoryStatus === void 0 ? void 0 : inventoryStatus.finished)) return false;
        return !inventory || !inventory.availableForSale && !isGiftCard;
    }, [
        inventory,
        inventoryStatus
    ]);
    var selectedStyles = (0,react.useMemo)(function() {
        if (isSoldOut && isGrouped) {
            return isSelected ? theme.value.unavailable.selected : theme.value.unavailable.unselected;
        }
        return isSelected ? theme.value.available.selected : theme.value.available.unselected;
    }, [
        isSelected,
        isSoldOut,
        isGrouped
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        as: "li",
        "data-comp": ColorOption.displayName,
        sx: theme.colorOptionWrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                "aria-label": color,
                variant: "buttons.plain",
                onClick: function() {
                    setSelectedOptions({
                        color: color
                    });
                },
                sx: (0,_object_spread/* default */.Z)({}, theme.value, selectedStyles || {}),
                style: isSoldOut && isGrouped ? {
                    background: "linear-gradient(to top left, transparent 0%, transparent calc(50% - 1px), currentColor 50%, transparent calc(50% + 1px), transparent 100%)"
                } : {},
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Picture */.t, {
                    alt: color,
                    width: 130,
                    height: 130,
                    images: [
                        {
                            src: firstImage === null || firstImage === void 0 ? void 0 : firstImage.originalSrc,
                            ratio: 1,
                            width: 54
                        }, 
                    ],
                    sx: {
                        opacity: isSoldOut && !isSelected && isGrouped ? 0.4 : 1,
                        zIndex: isSoldOut && isGrouped ? -1 : 0
                    }
                })
            }),
            color && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: theme.colorName,
                children: color
            })
        ]
    });
});
ColorOption.displayName = "ColorOption";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/ColorOptions/ColorOptions.jsx









// Enhanced ColorOption that includes badge information
function ColorOptionWithBadge(param) {
    var handle = param.handle, selectedColor = param.selectedColor, setSelectedOptions = param.setSelectedOptions, inventory = param.inventory, activeTab = param.activeTab, onCategoryDetected = param.onCategoryDetected;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var isLimitedEdition = (0,react.useMemo)(function() {
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.some(function(tag) {
            return tag.toLowerCase().includes("badge::limited edition");
        });
    }, [
        product === null || product === void 0 ? void 0 : product.tags
    ]);
    var isPersonalized = (0,react.useMemo)(function() {
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.some(function(tag) {
            return tag.toLowerCase().includes("personalized-enabled");
        });
    }, [
        product === null || product === void 0 ? void 0 : product.tags
    ]);
    // Report category to parent when product data is loaded
    (0,react.useEffect)(function() {
        if (product && onCategoryDetected) {
            onCategoryDetected(handle, {
                isLimitedEdition: isLimitedEdition,
                isPersonalized: isPersonalized,
                isCore: !isLimitedEdition
            });
        }
    }, [
        product,
        handle,
        isLimitedEdition,
        isPersonalized,
        onCategoryDetected
    ]);
    // Filter logic
    var shouldShow = (0,react.useMemo)(function() {
        if (activeTab === "all") return true;
        if (activeTab === "limited") return isLimitedEdition;
        if (activeTab === "personalize") return isPersonalized;
        if (activeTab === "core") return !isLimitedEdition;
        return true;
    }, [
        activeTab,
        isLimitedEdition,
        isPersonalized
    ]);
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOption, {
        handle: handle,
        selectedColor: selectedColor,
        setSelectedOptions: setSelectedOptions,
        isGrouped: true,
        inventory: inventory
    });
}
var ColorOptions = ColorOptions_theme_themed(function(param) {
    var theme = param.theme, product = param.product;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedOptions */.C)(), 2), selectedOptions = ref[0], setSelectedOptions = ref[1];
    var ref1 = (0,react.useState)("all"), activeTab = ref1[0], setActiveTab = ref1[1];
    var selectedColor = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.color;
    var handles = product.groupOptionsMap.handle;
    var handlesWithInventory = (0,hooks/* useProductInventoryByHandles */.$E)({
        handles: handles
    }) || [];
    // Track product categories as they're detected
    var ref2 = (0,react.useState)(new Set()), detectedCategories = ref2[0], setDetectedCategories = ref2[1];
    // Handle category detection from child components
    var handleCategoryDetected = (0,react.useMemo)(function() {
        var detectedHandles = new Set();
        return function(handle, categories) {
            if (detectedHandles.has(handle)) return; // Prevent duplicate counting
            detectedHandles.add(handle);
            setDetectedCategories(function(prev) {
                var newCategories = new Set(prev);
                if (categories.isLimitedEdition) newCategories.add("limited");
                if (categories.isPersonalized) newCategories.add("personalize");
                if (categories.isCore) newCategories.add("core");
                return newCategories;
            });
        };
    }, []);
    // Define all possible tabs
    var allTabs = [
        {
            id: "all",
            label: "All"
        },
        {
            id: "limited",
            label: "Limited Edition"
        },
        {
            id: "core",
            label: "Core"
        },
        {
            id: "personalize",
            label: "Personalize"
        }, 
    ];
    // Filter tabs to only show those with products (always show 'all' if there are any products)
    var visibleTabs = allTabs.filter(function(tab) {
        if (tab.id === "all") return handlesWithInventory.length > 0;
        return detectedCategories.has(tab.id);
    });
    // Reset to 'all' tab if current tab becomes invisible
    (0,react.useEffect)(function() {
        if (visibleTabs.length > 0 && !visibleTabs.some(function(tab) {
            return tab.id === activeTab;
        })) {
            setActiveTab("all");
        }
    }, [
        visibleTabs,
        activeTab
    ]);
    return product.isGrouped && (handlesWithInventory === null || handlesWithInventory === void 0 ? void 0 : handlesWithInventory.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": ColorOptions.displayName,
        sx: theme.option,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.tabs,
                children: visibleTabs.map(function(tab) {
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                        variant: "buttons.plain",
                        onClick: function() {
                            return setActiveTab(tab.id);
                        },
                        sx: (0,_object_spread/* default */.Z)({}, theme.tab, activeTab === tab.id ? theme.tab.active : {}),
                        children: tab.label
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                as: "ul",
                sx: theme.colorGrid,
                children: handlesWithInventory.map(function(handle) {
                    var ref, ref1;
                    /*#__PURE__*/ return (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOptionWithBadge, {
                        handle: handle === null || handle === void 0 ? void 0 : (ref = handle.inventory) === null || ref === void 0 ? void 0 : ref.handle,
                        selectedColor: selectedColor,
                        setSelectedOptions: setSelectedOptions,
                        inventory: handle === null || handle === void 0 ? void 0 : handle.inventory,
                        activeTab: activeTab,
                        onCategoryDetected: handleCategoryDetected
                    }, handle === null || handle === void 0 ? void 0 : (ref1 = handle.inventory) === null || ref1 === void 0 ? void 0 : ref1.handle);
                })
            })
        ]
    }) : null;
});
ColorOptions.displayName = "ColorOptions";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/ColorOptions/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/AddToCart/AddToCart.theme.js

var AddToCart_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: 11
    };
    // todo: nested variants should really be button variants that modify primary
    // so that they can be used through a project and not just here
    this.button = {
        variant: "primary",
        flex: 1,
        outline: "none",
        available: {
            cursor: "pointer",
            oneTime: {
                bg: "black"
            },
            subscribe: {
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                bg: "dark",
                "&:hover": {
                    color: "dark"
                }
            }
        },
        unavailable: {
            // cursor: 'default',
            oneTime: {
                variant: "buttons.secondary",
                color: "mediumDarkGray"
            },
            subscribe: {
                bg: "gray",
                border: function(t) {
                    return "1px solid ".concat(t.colors.dark);
                },
                "&:hover": {
                    bg: "gray",
                    color: "background"
                }
            }
        }
    };
    this.quantityWrapper = {
        variant: "flex.row.start.center",
        mr: 0,
        "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0
        },
        "input[type=number]": {
            MozAppearance: "textfield"
        }
    };
    this.quantityButton = {
        cursor: "pointer",
        width: "32px",
        height: "32px",
        minWidth: "32px",
        borderRadius: "50%",
        border: function(t) {
            return "1px solid ".concat(t.colors.gray);
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.15s ease-in-out",
        ":hover": {
            borderColor: "mediumDarkGray"
        }
    };
    this.buttonIcon = {
        width: "16px",
        color: "text"
    };
    this.quantity = {
        variant: "text.label.1",
        width: "34px",
        textAlign: "center",
        mx: 5
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/AddToCart/QuantitySelector.jsx









var QuantitySelector = AddToCart_theme_themed(function(param) {
    var theme = param.theme, quantity = param.quantity, setQuantity = param.setQuantity, isMaxed = param.isMaxed, maxQty = param.maxQty, qtyInCart = param.qtyInCart;
    var ref = (0,react.useState)(null), updatedAt = ref[0], setUpdatedAt = ref[1];
    var ref1 = (0,react.useState)(false), isUpdating = ref1[0], setIsUpdating = ref1[1];
    var disabled = quantity <= 1;
    var handleDecrement = (0,react.useCallback)(function() {
        if (disabled || isUpdating) return;
        setQuantity(quantity - 1);
        setUpdatedAt(new Date());
        setIsUpdating(true);
        setTimeout(function() {
            return setIsUpdating(false);
        }, 700);
    }, [
        disabled,
        quantity,
        isUpdating
    ]);
    var handleIncrement = (0,react.useCallback)(function() {
        if (isMaxed || isUpdating) return;
        setQuantity(quantity + 1);
        setUpdatedAt(new Date());
        setIsUpdating(true);
        setTimeout(function() {
            return setIsUpdating(false);
        }, 700);
    }, [
        isMaxed,
        quantity,
        isUpdating
    ]);
    var handleInputChange = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var typedQuantity, remainder;
            return (0,tslib_es6.__generator)(this, function(_state) {
                typedQuantity = parseInt(e.target.value, 10);
                if (!typedQuantity) {
                    setQuantity(quantity);
                } else if (typedQuantity < 1) {
                    setQuantity(1);
                } else if (typedQuantity + qtyInCart > maxQty) {
                    remainder = maxQty - qtyInCart;
                    setQuantity(remainder > 0 ? remainder : 1);
                } else {
                    setQuantity(typedQuantity);
                }
                setUpdatedAt(new Date());
                setIsUpdating(true);
                setTimeout(function() {
                    return setIsUpdating(false);
                }, 700);
                return [
                    2
                ];
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        quantity,
        maxQty,
        qtyInCart
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
        "data-comp": QuantitySelector.displayName,
        sx: theme.quantityWrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.plain",
                onClick: handleDecrement,
                disabled: disabled || isUpdating,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.quantityButton), {
                    cursor: disabled || isUpdating ? "default" : "pointer",
                    ":hover": {
                        borderColor: disabled || isUpdating ? "gray" : "mediumGray"
                    }
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                    viewBox: "0 0 48 48",
                    alt: "Decrease quantity",
                    src: "/svgs/minus.svg#minus",
                    loading: "lazy",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.buttonIcon), {
                        color: disabled || isUpdating ? "mediumDarkGray" : "text"
                    })
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: {
                    variant: "flex.row.center.center",
                    flex: 1,
                    mx: 2,
                    position: "relative",
                    height: "100%",
                    width: "44px"
                },
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        as: theme_ui_components_esm/* Input */.II,
                        type: "number",
                        min: "1",
                        max: maxQty ? maxQty - qtyInCart : null,
                        name: "quantity",
                        tabIndex: "-1",
                        "aria-hidden": "true",
                        defaultValue: quantity,
                        onBlur: handleInputChange,
                        onKeyDown: function(e) {
                            if (e.key === "Enter") {
                                handleInputChange(e);
                            }
                        },
                        sx: {
                            visibility: isUpdating ? "hidden" : "visible",
                            fontSize: 4,
                            fontFamily: "body",
                            width: "100%",
                            height: "100%",
                            textAlign: "center",
                            p: 0,
                            bg: "transparent",
                            outline: "none",
                            borderStyle: "none",
                            ":focus, :hover": {
                                outline: "none !important"
                            },
                            "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                                MozAppearance: "none",
                                margin: 0
                            },
                            MozAppearance: "textfield"
                        }
                    }, updatedAt),
                    isUpdating && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Spinner */.$j, {
                        sx: {
                            width: "20px",
                            color: "mediumGray",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                variant: "buttons.plain",
                onClick: handleIncrement,
                disabled: isMaxed || isUpdating,
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.quantityButton), {
                    cursor: isMaxed || isUpdating ? "default" : "pointer",
                    ":hover": {
                        borderColor: isMaxed || isUpdating ? "gray" : "mediumGray"
                    }
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                    viewBox: "0 0 48 48",
                    alt: "Increase quantity",
                    src: "/svgs/plus.svg#plus",
                    loading: "lazy",
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.buttonIcon), {
                        color: isMaxed || isUpdating ? "mediumDarkGray" : "text"
                    })
                })
            })
        ]
    });
});
QuantitySelector.displayName = "QuantitySelector";

// EXTERNAL MODULE: ../node_modules/@intelligems/headless/dist/pack.mjs + 1 modules
var pack = __webpack_require__(96807);
;// CONCATENATED MODULE: ./src/templates/product/Main/Details/AddToCart/useAddToCart.js










var useAddToCart = function(param) {
    var selectedVariant = param.selectedVariant, product = param.product;
    var ref, ref1;
    var gotoSnapshot = (0,store/* useGotoRecoilSnapshot */.le)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSelectedPlan */.JM)({
        selectedVariant: selectedVariant
    }), 1), selectedPlan = ref2[0];
    var cart = (0,dist.useCart)();
    var wrapCustomAttributes = (0,pack/* useIgCart */.Gx)(cart === null || cart === void 0 ? void 0 : cart.id).wrapCustomAttributes;
    var _ref = (0,dist.useCartAddItem)(), cartAddItem = _ref.cartAddItem, addItemStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartAddItem"
    ]);
    var _ref1 = (0,dist.useProductInventoryByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle,
        withQuantity: true
    }), inventory = _ref1.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref1, [
        "inventory"
    ]);
    // use live inventory data
    var variantStorefrontId = (0,utils/* isEncoded */.x)(inventory === null || inventory === void 0 ? void 0 : inventory.id) ? (0,utils/* getEncodedId */.m4)(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId) : selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.storefrontId;
    var variantInventory = inventory ? inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : ref[variantStorefrontId] : null;
    var isGiftCard = (variantInventory === null || variantInventory === void 0 ? void 0 : (ref1 = variantInventory.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === "brumate-e-gift-card" || (product === null || product === void 0 ? void 0 : product.handle) === "brumate-e-gift-card";
    var isSoldOut = !variantInventory || variantInventory.quantityAvailable <= 0 && !isGiftCard;
    var isPreOrder = isSoldOut && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.inventoryPolicy) === "CONTINUE";
    var toggleCartSidebar = (0,store/* useRecoilCallback */._8)(function(param) {
        var snapshot = param.snapshot;
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var release, updatedState;
            return (0,tslib_es6.__generator)(this, function(_state) {
                release = snapshot.retain();
                try {
                    updatedState = snapshot.map(function(param) {
                        var set = param.set;
                        return set(store/* default.modal */.ZP.modal, null);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.overlay */.ZP.overlay, true);
                    }).map(function(param) {
                        var set = param.set;
                        return set(store/* default.sidebar */.ZP.sidebar, "cart");
                    });
                    // update state
                    gotoSnapshot(updatedState);
                } finally{
                    release();
                }
                return [
                    2
                ];
            });
        });
    });
    // add oneTime and subs
    var addToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, _quantity, quantity, callback, _openCart, openCart, ref1, item, cart;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {
                        quantity: 1,
                        openCart: true
                    }, _quantity = ref.quantity, quantity = _quantity === void 0 ? 1 : _quantity, callback = ref.callback, _openCart = ref.openCart, openCart = _openCart === void 0 ? true : _openCart;
                    if (!selectedVariant || isSoldOut && !isPreOrder || typeof quantity !== "number") return [
                        2
                    ];
                    item = {
                        merchandiseId: selectedVariant.id,
                        quantity: quantity
                    };
                    // adds shipscout attribute to collect data for abtest
                    if (typeof window.ShipScoutLineItemProperty !== "undefined") {
                        item.attributes = [
                            {
                                key: "_sc",
                                value: window.ShipScoutLineItemProperty
                            }, 
                        ];
                    }
                    if ((selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.id) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id)) {
                        item.attributes = wrapCustomAttributes({
                            productId: selectedVariant.product.id,
                            variantId: selectedVariant.id,
                            subscribeAndSave: false,
                            customAttributes: item.attributes
                        });
                    }
                    if (typeof window.ShipScoutTrackAddToCart === "function") {
                        window.ShipScoutTrackAddToCart();
                    }
                    // if selling plan is selected we the subscription
                    if (selectedPlan) {
                        item.sellingPlanId = selectedPlan.id;
                    }
                    return [
                        4,
                        cartAddItem(item)
                    ];
                case 1:
                    cart = _state.sent();
                    if (cart) {
                        if (typeof callback === "function") {
                            callback(cart);
                        }
                        if (openCart) {
                            toggleCartSidebar();
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        isSoldOut,
        isPreOrder,
        selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.id
    ]);
    return [
        {
            isPreOrder: isPreOrder,
            isSoldOut: isSoldOut,
            selectedPlan: selectedPlan,
            status: {
                addItem: addItemStatus,
                inventory: inventory,
                inventoryStatus: inventoryStatus
            }
        },
        {
            addToCart: addToCart,
            toggleCartSidebar: toggleCartSidebar
        }, 
    ];
};

// EXTERNAL MODULE: ./src/theme/index.js + 16 modules
var theme = __webpack_require__(30450);
;// CONCATENATED MODULE: ./src/templates/product/Main/Header/AfterPay/AfterPay.theme.js

var AfterPay_theme_themed = (0,create/* create */.U)(new function() {
    this.afterpay = {
        variant: "flex.row.start.center",
        text: {
            color: "mediumDarkGray",
            fontSize: [
                3,
                4
            ],
            mb: 0
        },
        link: {
            ml: 2
        },
        pill: {
            width: [
                "56px",
                "62px"
            ],
            marginTop: "2px",
            borderRadius: "10px",
            bg: "#FFFFFF",
            position: "relative",
            overflow: "hidden"
        },
        logo: {
            width: [
                "56px",
                "62px"
            ]
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Header/AfterPay/AfterPay.jsx






// export function AfterPay({ price, variantId, currency, themeSettings }) {
var AfterPay = AfterPay_theme_themed(function(param) {
    var themeSettings = param.theme, price = param.price, variantId = param.variantId, currency = param.currency;
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, [
        variantId
    ]);
    var handleClick = function(evt) {
        if (typeof Afterpay === "object") {
            evt.preventDefault();
            window.Afterpay.launchModal("en_US-theme-white");
        }
    };
    if (!mounted) return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
        className: "bg-background absolute inset-0 h-full bg-white"
    });
    return price >= 35 ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        className: "relative -mt-1 md:mt-0 flex items-baseline text-[#8C8C8D]",
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("afterpay-placement", {
                "data-locale": "en_US",
                "data-currency": currency || "USD",
                "data-amount": price,
                "data-modal-theme": "white",
                "data-logo-type": "compact-badge",
                "data-modal-link-style": "none",
                id: "after-pay",
                "data-intro-text": "Pay in"
            }),
            !mounted && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "bg-background absolute inset-0 h-full bg-white"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("style", {
                children: "afterpay-placement{\n            margin: 0;\n            color: ".concat(theme/* theme.colors.mediumDarkGray */.r.colors.mediumDarkGray, ";\n            --messaging-font-size: ").concat(theme/* theme.fontSizes.4 */.r.fontSizes[4], ";\n            --logo-badge-width: 62px;\n          }\n          @media (max-width: 767px) {\n            afterpay-placement{\n              --messaging-font-size: ").concat(theme/* theme.fontSizes.3 */.r.fontSizes[3], ";\n              --logo-badge-width: 56px;\n            }\n          }\n        ")
            })
        ]
    }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                sx: themeSettings.afterpay.text,
                children: "Interest-free installments by"
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                href: "https://www.afterpay.com/en-US/terms-of-service",
                newTab: true,
                sx: themeSettings.afterpay.link,
                onClick: handleClick,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: themeSettings.afterpay.pill,
                    children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Svg */.ny, {
                        alt: "afterpay",
                        src: "/svgs/afterpay.svg",
                        viewBox: "0 0 98 24",
                        sx: themeSettings.afterpay.logo
                    })
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./src/templates/product/Main/Header/AfterPay/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/AddToCart/AddToCart.jsx














var AddToCart = AddToCart_theme_themed(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant, rebuyProducts = param.rebuyProducts;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var gatedPage = (0,store/* useRecoilValue */.sJ)(store/* default.gatedPage */.ZP.gatedPage);
    var enableFullProductAccess = (0,hooks/* useGatedProduct */.sC)({
        product: product,
        gatedPage: gatedPage
    }).enableFullProductAccess;
    var productByHandle = (0,dist.useProductByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle
    });
    var settings = (0,dist.useSettings)();
    var cart = (0,dist.useCart)();
    // logic to only show Rebuy mystery item once
    var hasMysteryItem = (0,react.useMemo)(function() {
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.some(function(line) {
            var ref, ref1;
            return (line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === "mystery-item";
        });
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    var crossSells = rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref1 = rebuyProducts.crossSells) === null || ref1 === void 0 ? void 0 : ref1.products;
    var upSells = rebuyProducts === null || rebuyProducts === void 0 ? void 0 : (ref2 = rebuyProducts.upSells) === null || ref2 === void 0 ? void 0 : ref2.products;
    if (hasMysteryItem) {
        crossSells = crossSells === null || crossSells === void 0 ? void 0 : crossSells.filter(function(_product) {
            return (_product === null || _product === void 0 ? void 0 : _product.handle) !== "mystery-item";
        });
        upSells = upSells === null || upSells === void 0 ? void 0 : upSells.filter(function(_product) {
            return (_product === null || _product === void 0 ? void 0 : _product.handle) !== "mystery-item";
        });
    }
    var ref8 = (0,_sliced_to_array/* default */.Z)(useAddToCart({
        product: productByHandle.product,
        selectedVariant: selectedVariant
    }), 2), ref9 = ref8[0], status = ref9.status, isSoldOut = ref9.isSoldOut, isPreOrder = ref9.isPreOrder, selectedPlan = ref9.selectedPlan, addToCart = ref8[1].addToCart;
    var _addItem = status.addItem, started = _addItem.started, finished = _addItem.finished, success = _addItem.success, errors = _addItem.errors;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useModal */.dd)(), 2), openModal = ref10[1].openModal;
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSidebar */.Ap)(), 2), openSidebar = ref11[1].openSidebar;
    var notifyMeText = (0,hooks/* useBreakpointValue */.Sx)([
        "Notify Me",
        "Notify Me When Available", 
    ]);
    var gwp = (0,hooks/* useGiftWithPurchase */.tG)();
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useCartStatus */.T0)(), 2), ref13 = ref12[1], setAddingToCartStatus = ref13.setAddingToCartStatus, setUpdatingCartStatus = ref13.setUpdatingCartStatus;
    var ref14 = (0,react.useState)(1), quantity = ref14[0], setQuantity = ref14[1];
    var ref15 = (0,react.useState)(false), isMaxed = ref15[0], setIsMaxed = ref15[1];
    var ref16 = (0,react.useState)(false), isOverMax = ref16[0], setIsOverMax = ref16[1];
    var ref17 = (0,react.useState)(0), qtyInCart = ref17[0], setQtyInCart = ref17[1];
    var ref18 = (settings === null || settings === void 0 ? void 0 : (ref3 = settings.cart) === null || ref3 === void 0 ? void 0 : ref3.bulkOrdering) || {}, maxQty = ref18.maxQty, _errorMessage = ref18.errorMessage, errorMessage = _errorMessage === void 0 ? "Please contact bulkorders@brumate.com for orders over 150." : _errorMessage, ignoredProducts = ref18.ignoredProducts;
    var cartItems = cart === null || cart === void 0 ? void 0 : cart.lines;
    var noBackInStockOption = isSoldOut && !isPreOrder && (product === null || product === void 0 ? void 0 : (ref4 = product.tags) === null || ref4 === void 0 ? void 0 : ref4.includes("no-bis"));
    var text = !(status === null || status === void 0 ? void 0 : (ref5 = status.inventoryStatus) === null || ref5 === void 0 ? void 0 : ref5.started) && product ? noBackInStockOption ? "Sold Out" : isSoldOut && !isPreOrder ? notifyMeText : isPreOrder ? "Pre-order" : selectedPlan ? "Subscribe" : "Add to Bag" : "Loading...";
    var ignoredFromMaxQty = (0,react.useMemo)(function() {
        return ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
            var ignoredProduct = param.product;
            return ignoredProduct.handle === (product === null || product === void 0 ? void 0 : product.handle);
        });
    }, [
        product === null || product === void 0 ? void 0 : product.handle,
        ignoredProducts
    ]);
    var checkIfCartIsMaxedOnQtyChange = (0,react.useCallback)(function() {
        if (!maxQty) return false;
        var totalProductsInCart = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function(total, param) {
            var variant = param.variant, itemQty = param.quantity;
            if (ignoredProducts === null || ignoredProducts === void 0 ? void 0 : ignoredProducts.some(function(param) {
                var ignoredProduct = param.product;
                return ignoredProduct.handle === variant.product.handle;
            })) {
                return total;
            }
            return total + itemQty;
        }, 0)) || 0;
        setQtyInCart(totalProductsInCart);
        setIsMaxed(totalProductsInCart + quantity >= maxQty);
        setIsOverMax(totalProductsInCart + quantity > maxQty);
        return true;
    }, [
        quantity,
        maxQty,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        ignoredProducts
    ]);
    var setGlobalCartStatusOnAdding = (0,react.useCallback)(function() {
        setAddingToCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        setUpdatingCartStatus({
            started: started,
            finished: finished,
            success: success,
            errors: errors
        });
        var defaultStatus = {
            started: false,
            finished: false,
            success: false,
            errors: []
        };
        return function() {
            setAddingToCartStatus(defaultStatus);
            setUpdatingCartStatus(defaultStatus);
        };
    }, [
        started,
        finished,
        success
    ]);
    var handleOutOfStock = (0,react.useCallback)(function() {
        openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* BackInStockModal */.Yu, {
            legacyResourceId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId,
            title: product === null || product === void 0 ? void 0 : product.title
        }));
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        product === null || product === void 0 ? void 0 : product.title
    ]);
    (0,react.useEffect)(function() {
        setGlobalCartStatusOnAdding();
    }, [
        started,
        finished,
        success
    ]);
    (0,react.useEffect)(function() {
        checkIfCartIsMaxedOnQtyChange();
    }, [
        quantity,
        maxQty,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        ignoredProducts
    ]);
    var isNotifyMe = isSoldOut && !isPreOrder;
    var overMaxDisabled = isOverMax && !isNotifyMe && !ignoredFromMaxQty;
    if (!enableFullProductAccess) return null;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        sx: {
            mt: [
                10,
                13
            ],
            mb: [
                11,
                13
            ],
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
                "data-comp": AddToCart.displayName,
                sx: theme.wrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(QuantitySelector, {
                        quantity: quantity,
                        setQuantity: setQuantity,
                        isMaxed: isMaxed && !ignoredFromMaxQty,
                        maxQty: maxQty,
                        qtyInCart: qtyInCart
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* StatefulButton */.Lc, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        disabled: !product || overMaxDisabled || noBackInStockOption,
                        loading: !(status === null || status === void 0 ? void 0 : (ref6 = status.inventoryStatus) === null || ref6 === void 0 ? void 0 : ref6.finished) && (status === null || status === void 0 ? void 0 : (ref7 = status.inventoryStatus) === null || ref7 === void 0 ? void 0 : ref7.started),
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button, isNotifyMe || overMaxDisabled || noBackInStockOption ? (0,_object_spread/* default */.Z)({}, theme.button.unavailable, selectedPlan ? theme.button.unavailable.subscribe : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.button.unavailable.oneTime), {
                            borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                            color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "mediumDarkGray",
                            ":hover": {
                                borderColor: overMaxDisabled || noBackInStockOption ? "gray" : "text",
                                color: overMaxDisabled || noBackInStockOption ? "mediumGray" : "text",
                                bg: "background"
                            }
                        })) : (0,_object_spread/* default */.Z)({}, theme.button.available, selectedPlan ? theme.button.available.subscribe : theme.button.available.oneTime)), {
                            cursor: !product || overMaxDisabled || noBackInStockOption ? "default" : "pointer"
                        })
                    }, status.addItem), {
                        text: {
                            default: text,
                            started: "Adding",
                            success: "Added",
                            error: "Failed To Add"
                        },
                        onClick: function() {
                            if (isNotifyMe) {
                                handleOutOfStock();
                            } else {
                                addToCart({
                                    quantity: quantity,
                                    callback: function(_cart) {
                                        if (gwp.isEligible(_cart)) {
                                            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* GiftWithPurchase */.QT, {}));
                                        } else if ((crossSells === null || crossSells === void 0 ? void 0 : crossSells.length) || (upSells === null || upSells === void 0 ? void 0 : upSells.length)) {
                                            openModal(/*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* RebuyModal */.oI, {
                                                rebuyProducts: rebuyProducts,
                                                productHandle: product.handle
                                            }));
                                        } else {
                                            openSidebar("cart");
                                        }
                                    },
                                    openCart: false
                                });
                            }
                        }
                    })),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Favorite */.rF, {
                        selectedVariant: selectedVariant,
                        isPdp: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.afterpay), {
                    mt: [
                        "12px"
                    ],
                    justifyContent: "center",
                    alignItems: "center"
                }),
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AfterPay, {
                    currency: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currencyCode,
                    variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.legacyResourceId,
                    price: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price
                })
            }),
            isMaxed && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
                text: errorMessage,
                sx: {
                    mt: 7,
                    a: {
                        textDecoration: "none"
                    }
                },
                textSx: {
                    variant: "text.label.2",
                    color: "red"
                }
            })
        ]
    });
});
AddToCart.displayName = "AddToCart";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/AddToCart/index.js


// EXTERNAL MODULE: ./src/templates/product/Main/Details/Personalize/index.js + 3 modules
var Personalize = __webpack_require__(13542);
;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Metadata/StoreLocator/StoreLocator.jsx



function StoreLocator(param) {
    var selectedVariant = param.selectedVariant, locallyInjected = param.locallyInjected, setLocallyInjected = param.setLocallyInjected;
    var id = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id;
    var upc = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.barcode;
    var ref = (0,react.useState)(false), loaded = ref[0], setLoaded = ref[1];
    var reloadLocallyOnVariantChange = (0,react.useCallback)(function() {
        try {
            if (!id || typeof window.lcly_reload_0 !== "function") return;
            window.lcly_reload_0({
                upc: upc || ""
            });
        } catch (error) {
            console.error(error.message);
        }
    }, [
        id,
        locallyInjected,
        upc
    ]);
    (0,react.useEffect)(function() {
        var t = document.getElementById("lcly-script-0");
        t && t.parentNode.removeChild(t);
        setLoaded(true);
        return function() {
            setLoaded(false);
        };
    }, []);
    (0,react.useEffect)(function() {
        if ( true && loaded && !locallyInjected) {
            var lclyConfig = {
                company_name: "Br\xfcMate",
                button_text: ":heart:",
                button_id: "HTML",
                company_id: "156418",
                css: "6",
                upc: upc || "",
                n_related_styles: "3",
                show_location_prompt: "1",
                lang: "en-us",
                show_dealers: "1",
                n_dealers: "3",
                show_location_switcher: "1"
            };
            var lclyQuery = Object.keys(lclyConfig).reduce(function(a, k) {
                a.push("".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(lclyConfig[k])));
                return a;
            }, []).join("&");
            var lclyEndpoint = "https://brumate.locally.com/stores/map.js?".concat(lclyQuery, "&v=").concat(Date.now());
            var js = window.document.createElement("script");
            js.src = lclyEndpoint;
            js.type = "text/javascript";
            js.fetchPriority = "high";
            js.id = "lcly-script-0";
            document.head.appendChild(js);
            setLocallyInjected(true);
        }
        return function() {
            var t = document.getElementById("lcly-script-0");
            t && t.parentNode.removeChild(t);
            setLocallyInjected(false);
        };
    }, [
        loaded,
        id
    ]);
    (0,react.useEffect)(function() {
        if (locallyInjected) {
            reloadLocallyOnVariantChange();
        }
    }, [
        loaded,
        id,
        locallyInjected
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": StoreLocator.displayName,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
            id: "lcly-button-0",
            className: "lcly-pl-widget-parent",
            "data-switchlive": "true",
            "data-switchlive-impression": "true",
            "data-switchlive-impression-id-pl": "1",
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("a", {
                id: "lcly-link-0",
                "data-switchlive": "true",
                "data-switchlive-mode": "auto",
                "data-switchlive-id-pl": "6",
                href: "https://join.locally.com/for-brands",
                target: "_blank",
                rel: "noreferrer",
                children: "Product Locator by Locally"
            })
        })
    });
}
StoreLocator.displayName = "StoreLocator";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Metadata/StoreLocator/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Metadata/Metadata.theme.js

var Metadata_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%"
    };
    this.tabs = {
        width: "100%",
        borderBottom: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
    this.tab = function(isActive) {
        return {
            pb: [
                4,
                6
            ],
            px: [
                4,
                5
            ],
            position: "relative",
            ":after": {
                content: '""',
                height: "1px",
                width: "100%",
                maxWidth: isActive ? "100%" : "0%",
                bg: "text",
                position: "absolute",
                left: 0,
                top: "100%",
                transition: "max-width 0.15s ease-in-out"
            }
        };
    };
    this.tabTitle = {
        variant: "text.label.1",
        fontSize: [
            0,
            2
        ],
        lineHeight: 18
    };
    this.content = function(isActive) {
        return {
            display: isActive ? "block" : "none",
            width: "100%"
        };
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Metadata/Metadata.jsx







var Metadata = Metadata_theme_themed(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var metafield = (0,dist.useProductMetafield)({
        handle: product === null || product === void 0 ? void 0 : product.handle,
        namespace: "my_fields",
        key: "specs_and_fitment"
    }).metafield;
    var ref6 = (0,react.useState)(0), activeIndex = ref6[0], setActiveIndex = ref6[1];
    var ref7 = (0,react.useState)(false), locallyInjected = ref7[0], setLocallyInjected = ref7[1];
    var settings = (0,dist.useSettings)();
    var guides = settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : (ref1 = ref.specs) === null || ref1 === void 0 ? void 0 : ref1.guides;
    var usageGuide = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.length) || !(guides === null || guides === void 0 ? void 0 : guides.length)) return;
        var productTag = product === null || product === void 0 ? void 0 : (ref1 = product.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(tag) {
            return tag.startsWith("usage-guide::");
        });
        var productGuide = guides === null || guides === void 0 ? void 0 : guides.find(function(guide) {
            var ref, ref1, ref2;
            return (guide === null || guide === void 0 ? void 0 : (ref = guide.tag) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === ((ref1 = productTag === null || productTag === void 0 ? void 0 : productTag.split("usage-guide::")) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[1]) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase().trim());
        });
        return productGuide;
    }, [
        product === null || product === void 0 ? void 0 : product.id,
        guides
    ]);
    var tabs = [
        {
            title: "Details",
            content: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    width: "100%",
                    py: 8,
                    borderBottomStyle: (product === null || product === void 0 ? void 0 : product.descriptionHtml) ? "solid" : "none",
                    borderBottomWidth: "1px",
                    borderBottomColor: "gray",
                    "ul, ol": {
                        pl: 0
                    },
                    "p, span": {
                        variant: "text.base",
                        mt: 0
                    },
                    "p:last-of-type": {
                        mb: 0
                    }
                },
                dangerouslySetInnerHTML: {
                    __html: product === null || product === void 0 ? void 0 : product.descriptionHtml
                }
            })
        },
        {
            title: "Specs & Fitment",
            content: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                        sx: {
                            py: 8,
                            fontSize: [
                                3,
                                4
                            ],
                            borderBottomStyle: (metafield === null || metafield === void 0 ? void 0 : metafield.value) && !usageGuide ? "solid" : "none",
                            borderBottomWidth: "1px",
                            borderBottomColor: "gray",
                            p: {
                                py: 0
                            }
                        },
                        dangerouslySetInnerHTML: {
                            __html: metafield === null || metafield === void 0 ? void 0 : (ref2 = metafield.value) === null || ref2 === void 0 ? void 0 : ref2.replaceAll("\n", "<br>")
                        }
                    }),
                    usageGuide && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: {
                            variant: "flex.row.start.center",
                            borderBottomStyle: "solid",
                            borderBottomWidth: "1px",
                            borderBottomColor: "gray",
                            py: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Image */.Ee, {
                                alt: usageGuide.tag,
                                src: "/svgs/pdf-logo.svg" || 0,
                                sx: {
                                    width: "30px",
                                    mr: 3
                                },
                                loading: "lazy"
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Link */.rU, {
                                variant: "buttons.link.1",
                                href: usageGuide === null || usageGuide === void 0 ? void 0 : (ref3 = usageGuide.cta) === null || ref3 === void 0 ? void 0 : ref3.url,
                                newTab: usageGuide === null || usageGuide === void 0 ? void 0 : (ref4 = usageGuide.cta) === null || ref4 === void 0 ? void 0 : ref4.newTab,
                                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                                    sx: {
                                        lineHeight: 18,
                                        fontWeight: 500,
                                        fontSize: [
                                            3,
                                            4
                                        ]
                                    },
                                    children: usageGuide === null || usageGuide === void 0 ? void 0 : (ref5 = usageGuide.cta) === null || ref5 === void 0 ? void 0 : ref5.text
                                })
                            })
                        ]
                    })
                ]
            })
        },
        {
            title: "Find a Local Dealer",
            content: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(StoreLocator, {
                selectedVariant: selectedVariant,
                locallyInjected: locallyInjected,
                setLocallyInjected: setLocallyInjected
            })
        }, 
    ];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Metadata.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.tabs,
                children: tabs.map(function(param, index) {
                    var title = param.title;
                    var isActive = index === activeIndex;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                        variant: "buttons.plain",
                        onClick: function() {
                            return setActiveIndex(index);
                        },
                        sx: theme.tab(isActive),
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Paragraph */.nv, {
                            sx: theme.tabTitle,
                            children: title
                        })
                    }, title);
                })
            }),
            tabs.map(function(param, index) {
                var title = param.title, content = param.content;
                var isActive = index === activeIndex;
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                    sx: theme.content(isActive),
                    children: content || null
                }, title);
            })
        ]
    });
});
Metadata.displayName = "Metadata";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Metadata/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Details.theme.js

var Details_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        width: "100%",
        overflowX: "hidden"
    };
    this.sticky = {
        alignSelf: "flex-start",
        justifySelf: "flex-end",
        position: "sticky",
        pt: [
            11,
            null,
            0
        ],
        top: "calc(var(--header-height) + var(--promoBar-height) + 20px)",
        width: "100%",
        wrapper: {
            variant: "flex.column"
        }
    };
    this.ctas = {
        variant: "flex.column.start",
        borderTop: function(t) {
            return "1px solid ".concat(t.colors.gray);
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Upsells/Upsells.jsx






function Upsells(param) {
    var selectedVariant = param.selectedVariant;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var ref2 = (settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.upsells) || {}, heading = ref2.heading, products = ref2.products;
    var upsellProducts = (0,react.useMemo)(function() {
        var ref;
        var tags = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.tags;
        var newUpsellHandles = tags === null || tags === void 0 ? void 0 : tags.reduce(function(carry, tag) {
            if (tag.indexOf("upsell::") > -1) {
                var ref = (0,_sliced_to_array/* default */.Z)(tag.split("::"), 3), handle = ref[1], order = ref[2];
                return (0,_to_consumable_array/* default */.Z)(carry).concat([
                    {
                        product: {
                            handle: handle,
                            order: order
                        }
                    }, 
                ]).sort(function(a, b) {
                    var ref, ref1;
                    return ((a === null || a === void 0 ? void 0 : (ref = a.product) === null || ref === void 0 ? void 0 : ref.order) || 0) - ((b === null || b === void 0 ? void 0 : (ref1 = b.product) === null || ref1 === void 0 ? void 0 : ref1.order) || 0);
                });
            }
            return carry;
        }, []);
        if (newUpsellHandles === null || newUpsellHandles === void 0 ? void 0 : newUpsellHandles.length) {
            return newUpsellHandles;
        }
        return products;
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.tags
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductUpsellsList */.gW, {
        heading: heading,
        products: upsellProducts
    });
}
Upsells.displayName = "Upsells";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Upsells/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/BuyWithPrime/BuyWithPrime.jsx


function BuyWithPrime(param) {
    var sku = param.sku;
    var ref = (0,react.useState)(0), count = ref[0], setCount = ref[1];
    (0,react.useEffect)(function() {
        if (true) {
            var js = window.document.createElement("script");
            js.src = "https://code.buywithprime.amazon.com/bwp.v1.js";
            js.type = "text/javascript";
            js.async = true;
            js.fetchPriority = "high";
            js.id = "bwpScript";
            document.head.appendChild(js);
        }
        return function() {
            var t = document.getElementById("bwpFrame");
            t && t.parentNode.removeChild(t);
            var s = document.getElementById("bwpScript");
            s && s.parentNode.removeChild(s);
        };
    }, []);
    (0,react.useEffect)(function() {
        var timer = setInterval(function() {
            if (count > 10) {
                clearInterval(timer);
            }
            if (typeof window.bwp === "object" && typeof window.bwp.updateWidget === "function" && sku && document.querySelector("#amzn-buy-now")) {
                clearInterval(timer);
                window.bwp.updateWidget(sku);
            } else {
                setCount(count + 1);
            }
        }, 500);
        return function() {
            return clearInterval(timer);
        };
    }, [
        sku,
        count
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)("div", {
        "data-prime-widget-sku": sku,
        className: "buy-with-prime-container m-auto w-full flex flex-col-reverse mb-6",
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                id: "amzn-buy-now",
                "data-site-id": "o3krsbin2k" || 0,
                "data-widget-id": "w-gfUDvYZJWj7eeyHQGn9uk6" || 0,
                "data-sku": sku
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                className: "or-separator",
                children: "OR"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/templates/product/Main/BuyWithPrime/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Details/Details.jsx













var Details = Details_theme_themed(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant, currentProduct = param.currentProduct, titles = param.titles, productUpsells = param.productUpsells, rebuyProducts = param.rebuyProducts, videoWise = param.videoWise;
    var ref, ref1;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": Details.displayName,
        sx: theme.wrapper,
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
            "data-comp": "StickyContainer",
            sx: theme.sticky,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.sticky.wrapper,
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                        sx: {
                            display: [
                                "none",
                                null,
                                "block"
                            ]
                        },
                        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header, {
                            selectedVariant: selectedVariant,
                            currentProduct: currentProduct,
                            titles: titles
                        })
                    }),
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Flex */.kC, {
                        sx: theme.ctas,
                        children: [
                            (product === null || product === void 0 ? void 0 : product.optionsMap) && selectedVariant ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Options, {
                                options: product === null || product === void 0 ? void 0 : product.optionsMap,
                                handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle,
                                image: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.image) === null || ref1 === void 0 ? void 0 : ref1.originalSrc
                            }) : null,
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(SizeOptions, {
                                product: currentProduct
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ColorOptions, {
                                product: product
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(AddToCart, {
                                product: currentProduct,
                                selectedVariant: selectedVariant,
                                rebuyProducts: rebuyProducts
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Personalize/* Personalize */.x, {
                                product: currentProduct
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(BuyWithPrime, {
                                sku: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku
                            }),
                            !!(videoWise === null || videoWise === void 0 ? void 0 : videoWise.length) && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("div", {
                                className: "w-full",
                                children: videoWise
                            }),
                            (productUpsells === null || productUpsells === void 0 ? void 0 : productUpsells.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                                sx: {
                                    width: "100%"
                                },
                                children: productUpsells[0]
                            }) : /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Upsells, {
                                selectedVariant: selectedVariant
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Icons, {
                                product: currentProduct
                            }),
                            currentProduct && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Metadata, {
                                product: currentProduct,
                                selectedVariant: selectedVariant
                            })
                        ]
                    })
                ]
            })
        })
    });
});
Details.displayName = "ProductDetails";

;// CONCATENATED MODULE: ./src/templates/product/Main/Details/index.js


;// CONCATENATED MODULE: ./src/templates/product/Main/Main.theme.js

var Main_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        variant: "layout.content",
        gridTemplateColumns: [
            "1fr",
            null,
            ".58fr .42fr"
        ],
        columnGap: [
            0,
            null,
            12
        ],
        pt: [
            2,
            11,
            14
        ],
        width: "100%",
        mb: [
            8,
            null,
            10,
            12
        ],
        medias: {
            width: "100%",
            flexShrink: 0
        },
        details: {
            width: "100%",
            sticky: {
                alignSelf: "flex-start",
                justifySelf: "flex-end",
                position: "sticky",
                pt: 4,
                top: "calc(var(--header-height) + var(--promoBar-height) + 20px)",
                width: "100%",
                wrapper: {
                    variant: "flex.column"
                }
            }
        },
        metadata: {
            maxWidth: "100%",
            title: {
                text: "text.h2"
            },
            price: {
                text: "text.h2"
            },
            description: {
                mt: 3,
                lineHeight: "18px"
            }
        },
        ctas: {
            variant: "flex.column.start"
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/product/Main/Main.jsx










var Main = Main_theme_themed(function(param) {
    var theme = param.theme, product = param.product, selectedVariant = param.selectedVariant, productUpsells = param.productUpsells, rebuyProducts = param.rebuyProducts, videoWise = param.videoWise;
    var ref, ref1, ref2;
    var ref3 = (0,dist.useProductByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle
    }), currentProduct = ref3.product;
    var sendViewProductEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewProductEvent;
    var titles = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var titleArr = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.split("|");
        return {
            product: (titleArr === null || titleArr === void 0 ? void 0 : (ref2 = titleArr[0]) === null || ref2 === void 0 ? void 0 : ref2.trim()) || "",
            variant: ((ref3 = titleArr === null || titleArr === void 0 ? void 0 : titleArr.slice(1)) === null || ref3 === void 0 ? void 0 : ref3.join("|").trim()) || ""
        };
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.title
    ]);
    (0,react.useEffect)(function() {
        sendViewProductEvent({
            product: product,
            selectedVariant: selectedVariant
        });
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref2 = selectedVariant.product) === null || ref2 === void 0 ? void 0 : ref2.handle,
        sendViewProductEvent
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Grid */.rj, {
        "data-comp": Main.displayName,
        sx: theme.wrapper,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("title", {
                    children: (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.title) || ""
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: {
                    display: [
                        "block",
                        null,
                        "none"
                    ]
                },
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header, {
                    selectedVariant: selectedVariant,
                    currentProduct: currentProduct,
                    titles: titles,
                    isMobile: true
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Media, {
                product: currentProduct,
                selectedVariant: selectedVariant,
                aboveTheFold: true,
                preload: true
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Details, {
                product: product,
                selectedVariant: selectedVariant,
                currentProduct: currentProduct,
                titles: titles,
                productUpsells: productUpsells,
                rebuyProducts: rebuyProducts,
                videoWise: videoWise
            })
        ]
    });
});
Main.displayName = "Main";

;// CONCATENATED MODULE: ./src/templates/product/Main/index.js


;// CONCATENATED MODULE: ./src/templates/product/useProductIntelliSuggest.js


function useProductIntelliSuggest(param) {
    var sku = param.sku;
    var shopperId = (0,store/* useRecoilValue */.sJ)(store/* default.shopperId */.ZP.shopperId);
    var ref = (0,react.useState)(false), mounted = ref[0], setMounted = ref[1];
    var setMountAfterDelayForCustomerId = (0,react.useCallback)(function() {
        setTimeout(function() {
            setMounted(true);
        }, 3000);
    }, []);
    var sendIntelliSuggestEventOnProductView = (0,react.useCallback)(function() {
        try {
            if (!sku || !mounted || !window.IntelliSuggest) return;
            if (window.__brumate_product_sku && window.__brumate_product_sku === sku) return;
            window.__brumate_product_sku = sku;
            window.IntelliSuggest.init({
                siteId: "nr3jmv",
                context: "Product/".concat(sku),
                seed: [
                    sku
                ]
            });
            if (shopperId) {
                window.IntelliSuggest.setShopperId(shopperId);
            }
            window.IntelliSuggest.viewItem({
                sku: sku
            });
        } catch (error) {
            console.error(error.message);
        }
    }, [
        sku,
        shopperId,
        mounted
    ]);
    (0,react.useEffect)(function() {
        setMountAfterDelayForCustomerId();
    }, []);
    (0,react.useEffect)(function() {
        sendIntelliSuggestEventOnProductView();
    }, [
        sku,
        mounted
    ]);
}

;// CONCATENATED MODULE: ./src/templates/product/ProductComponent.jsx













function handlelize(str) {
    var handle = str.normalize("NFD").replace(/[\[\]'()"]+/g, "") // Remove apostrophes, square brackets, and other bits and pieces
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/([^\w]+|\s+)/g, "-") // Replace space and other characters by hyphen
    .replace(/\-\-+/g, "-") // Replaces multiple hyphens by one hyphen
    .replace(/(^-+|-+$)/g, "") // Remove extra hyphens from beginning or end of the string
    .toLowerCase(); // To lowercase
    return handle;
}
function ProductComponent(param) {
    var product = param.product, sections = param.sections;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useRef)();
    var ref5 = (0,hooks/* usePickedSections */.FU)({
        anyOf: [
            "featuredTwoTile",
            "productUpsells",
            "videoWise"
        ],
        sections: sections
    }), anyOf = ref5.anyOf, otherSections = ref5.otherSections;
    var selectedVariant = (0,hooks/* useInitSelectedVariant */.ns)();
    var cart = (0,dist.useCart)();
    var cart_item_count = (0,dist.useCartCount)();
    var hasMysteryItem = (0,react.useMemo)(function() {
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.some(function(line) {
            var ref, ref1;
            return (line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === "mystery-item";
        });
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    var collectionHandle = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var title = product === null || product === void 0 ? void 0 : product.title;
        if ((product === null || product === void 0 ? void 0 : (ref = product.title) === null || ref === void 0 ? void 0 : ref.indexOf("|")) !== -1) {
            var ref4, ref5, ref6;
            title = ((ref5 = product === null || product === void 0 ? void 0 : (ref4 = product.title) === null || ref4 === void 0 ? void 0 : ref4.split("|")) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.trim()) || "";
        }
        var pHandle = handlelize(title);
        var collection = product === null || product === void 0 ? void 0 : (ref1 = product.collections) === null || ref1 === void 0 ? void 0 : ref1.find(function(c) {
            return pHandle === null || pHandle === void 0 ? void 0 : pHandle.includes(c === null || c === void 0 ? void 0 : c.handle);
        });
        if (collection === null || collection === void 0 ? void 0 : collection.handle) {
            return collection.handle;
        }
        return product === null || product === void 0 ? void 0 : (ref2 = product.collections) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.handle;
    }, [
        product === null || product === void 0 ? void 0 : product.title,
        product === null || product === void 0 ? void 0 : product.collections
    ]);
    var collection = (0,dist.useCollectionByHandle)({
        handle: collectionHandle
    }).collection;
    // pass the mystery-item to rebuy if it's already in the cart
    var cartProductIds = (0,react.useMemo)(function() {
        var ref;
        return (cart === null || cart === void 0 ? void 0 : (ref = cart.lines) === null || ref === void 0 ? void 0 : ref.map(function(line) {
            var ref, ref1;
            if ((line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.handle) === "mystery-item") {
                var ref2;
                var productId = (0,utils/* getValidId */.MM)((ref2 = line.variant.product) === null || ref2 === void 0 ? void 0 : ref2.id);
                return productId || null;
            }
            return null;
        })) || [];
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    var product_ids = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.legacyResourceId) || (product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.legacyResourceId);
    var shopify_product_ids = [
        product_ids
    ].concat((0,_to_consumable_array/* default */.Z)(cartProductIds)).join(",");
    var ref6 = (0,react.useState)(null), rebuyProducts = ref6[0], setRebuyProducts = ref6[1];
    var getRebuyProducts = (0,hooks/* useRebuy */.Fo)().getRebuyProducts;
    (0,react.useEffect)(function() {
        var handleRebuy = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, rebuyProductsData, crossSellProducts, upSellProducts;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                getRebuyProducts({
                                    shopify_product_ids: shopify_product_ids,
                                    cart_item_count: cart_item_count
                                })
                            ];
                        case 1:
                            rebuyProductsData = _state.sent();
                            crossSellProducts = rebuyProductsData === null || rebuyProductsData === void 0 ? void 0 : (ref = rebuyProductsData.crossSells) === null || ref === void 0 ? void 0 : ref.data;
                            upSellProducts = rebuyProductsData === null || rebuyProductsData === void 0 ? void 0 : (ref1 = rebuyProductsData.upSells) === null || ref1 === void 0 ? void 0 : ref1.data;
                            if (hasMysteryItem) {
                                crossSellProducts = crossSellProducts === null || crossSellProducts === void 0 ? void 0 : crossSellProducts.filter(function(_product) {
                                    return (_product === null || _product === void 0 ? void 0 : _product.handle) !== "mystery-item";
                                });
                                upSellProducts = upSellProducts === null || upSellProducts === void 0 ? void 0 : upSellProducts.filter(function(_product) {
                                    return (_product === null || _product === void 0 ? void 0 : _product.handle) !== "mystery-item";
                                });
                            }
                            setRebuyProducts({
                                crossSells: {
                                    products: crossSellProducts,
                                    language: rebuyProductsData === null || rebuyProductsData === void 0 ? void 0 : (ref2 = rebuyProductsData.crossSells) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.metadata) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.widget) === null || ref4 === void 0 ? void 0 : ref4.language
                                },
                                upSells: {
                                    products: upSellProducts,
                                    language: rebuyProductsData === null || rebuyProductsData === void 0 ? void 0 : (ref5 = rebuyProductsData.upSells) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.metadata) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.widget) === null || ref7 === void 0 ? void 0 : ref7.language
                                }
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleRebuy() {
                return _ref.apply(this, arguments);
            };
        }();
        if (shopify_product_ids) handleRebuy();
    }, [
        shopify_product_ids,
        hasMysteryItem
    ]);
    // send intellisuggest event on product view
    useProductIntelliSuggest({
        sku: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku
    });
    var setInitialProduct = (0,store/* useSetRecoilState */.Zl)(store/* default.initialProduct */.ZP.initialProduct);
    var id = (product === null || product === void 0 ? void 0 : product.legacyResourceId) || "";
    var updateLastViewedOnProductPage = (0,react.useCallback)(function() {
        var lastViewed = window.localStorage.getItem("lastViewed");
        if (lastViewed) {
            var lastViewedIds = lastViewed.split(",");
            if (!lastViewedIds.includes(id)) {
                window.localStorage.setItem("lastViewed", "".concat(id, ",").concat(lastViewedIds.slice(0, 4).join(",")));
            }
        } else {
            window.localStorage.setItem("lastViewed", id);
        }
    }, [
        id
    ]);
    (0,react.useEffect)(function() {
        updateLastViewedOnProductPage();
    }, [
        id
    ]);
    (0,react.useEffect)(function() {
        setInitialProduct(product);
    }, [
        id
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": ProductComponent.displayName,
        ref: ref4,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Breadcrumbs */.Oo, {
                selectedVariant: selectedVariant,
                isPdp: true,
                collection: collection
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Main, {
                product: product,
                selectedVariant: selectedVariant,
                productUpsells: anyOf.productUpsells,
                rebuyProducts: rebuyProducts,
                videoWise: anyOf === null || anyOf === void 0 ? void 0 : anyOf.videoWise
            }),
            otherSections || null,
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* ProductReviews */.Q4, {}),
            anyOf.featuredTwoTile || null
        ]
    });
}
ProductComponent.displayName = "ProductComponent";

;// CONCATENATED MODULE: ./src/templates/product/product.jsx


function ProductTemplate(param) {
    var product = param.product, renderSections = param.renderSections;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(ProductComponent, {
        product: product,
        sections: renderSections()
    });
}
ProductTemplate.displayName = "ProductTemplate";

;// CONCATENATED MODULE: ./src/templates/product/index.js

/* harmony default export */ var templates_product = (ProductTemplate);

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(93183);
;// CONCATENATED MODULE: ./src/pages/products/[handle].jsx
/* eslint-disable import/no-unresolved */ 









function DraftBadge() {
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)("p", {
        "data-comp": "DraftProductBadge",
        // eslint-disable-next-line react/no-unknown-property
        sx: {
            position: "fixed",
            right: 0,
            top: 175,
            transform: "rotate(-90deg)",
            transformOrigin: "bottom right",
            backgroundColor: "#433d51",
            color: "#FFF",
            px: "20px",
            py: "10px",
            fontSize: "14px",
            letterSpacing: "4px",
            fontWeight: 200
        },
        children: "DRAFT"
    });
}
var __N_SSG = true;
function Product(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var router = (0,next_router.useRouter)();
    var settingProduct = (0,react.useRef)(false);
    var product = props.product;
    var ref = (0,_sliced_to_array/* default */.Z)(dist.store.recoil.useRecoilState(dist.store.state.product), 2), recoilProduct = ref[0], setProduct = ref[1];
    var hasQueryParam = router.asPath.includes("?");
    var nextQueryParamReady = Object.keys(router.query).length > 1;
    var handlesMatch = (product === null || product === void 0 ? void 0 : product.handle) === (recoilProduct === null || recoilProduct === void 0 ? void 0 : recoilProduct.handle);
    (0,react.useEffect)(function() {
        if (!handlesMatch) {
            // load the product onto the recoil state
            settingProduct.current = true;
            setProduct(product);
        } else {
            settingProduct.current = false;
        }
        return function() {
            if (hasQueryParam && !nextQueryParamReady) {
                // if we are processing query params
                return;
            }
            if (!settingProduct.current) {
                // unload the product onto the recoil state
                setProduct(null);
            }
        };
    }, [
        handlesMatch
    ]);
    var productPage = props.page;
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PageHead */.yG, {
            page: productPage,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_jsx_runtime_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(templates_product, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        product: product,
                        renderSections: renderSections
                    })),
                    (product === null || product === void 0 ? void 0 : product.publishedAt) === null ? /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(DraftBadge, {}) : null
                ]
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8718); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);